import React, { useEffect, createElement } from 'react';
import { Button } from './Button';
export const HeroSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/6oqdjPAT?coupon_code=7DAYRESETSPECIAL2025';
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      (function (v, i, d, a, l, y, t, c, s) {
          y='_'+d.toLowerCase();c=d+'L';if(!v[d]){v[d]={};}if(!v[c]){v[c]={};}if(!v[y]){v[y]={};}var vl='Loader',vli=v[y][vl],vsl=v[c][vl + 'Script'],vlf=v[c][vl + 'Loaded'],ve='Embed';
          if (!vsl){vsl=function(u,cb){
              if(t){cb();return;}s=i.createElement("script");s.type="text/javascript";s.async=1;s.src=u;
              if(s.readyState){s.onreadystatechange=function(){if(s.readyState==="loaded"||s.readyState=="complete"){s.onreadystatechange=null;vlf=1;cb();}};}else{s.onload=function(){vlf=1;cb();};}
              i.getElementsByTagName("head")[0].appendChild(s);
          };}
          vsl('https://fast.vidalytics.com/embeds/4FbV_O2r/3Tgi7c7stheBGpTq/loader.min.js',function(){if(!vli){var vlc=v[c][vl];vli=new vlc();}vli.loadScript('https://fast.vidalytics.com/embeds/4FbV_O2r/3Tgi7c7stheBGpTq/player.min.js',function(){var vec=v[d][ve];t=new vec();t.run(a);});});
      })(window, document, 'Vidalytics', 'vidalytics_embed_3Tgi7c7stheBGpTq', 'https://fast.vidalytics.com/embeds/4FbV_O2r/3Tgi7c7stheBGpTq/');
    `;
    // Append to document
    document.head.appendChild(script);
    // Cleanup function
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []); // Empty dependency array ensures this runs only once
  return <section className="bg-gradient-to-b from-teal-900 to-teal-800 text-white py-16" data-id="element-210">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-211">
        <h1 className="flex flex-col gap-4 mb-8" data-id="element-212">
          <span className="text-3xl md:text-4xl font-bold text-center leading-tight" data-id="element-213">
            Your Body Isn't Broken. It's Just Stuck In Survival Mode.
          </span>
          <span className="text-2xl md:text-3xl font-medium text-center leading-tight bg-teal-800/50 py-2 px-4 rounded-lg italic" data-id="element-214">
            This 7-Day Reset Helps You Feel Calm, Grounded, and Safe — In Just
            Minutes A Day.
          </span>
        </h1>
        <div className="mb-12 max-w-3xl mx-auto" data-id="element-215">
          <div id="vidalytics_embed_3Tgi7c7stheBGpTq" style={{
          width: '100%',
          position: 'relative',
          paddingTop: '56.25%'
        }} data-id="element-216"></div>
        </div>
        <div className="mb-10 text-lg space-y-4" data-id="element-217">
          <p data-id="element-218">If you already understand that trauma lives in the body...</p>
          <p data-id="element-219">
            If you've read The Body Keeps the Score, followed Irene Lyon, or
            practiced somatic tools...
          </p>
          <p data-id="element-220">If you're tired of therapy that keeps you stuck in your head...</p>
          <p data-id="element-221">Then you're not early in your healing journey.</p>
          <p className="font-bold" data-id="element-222">You're just under-supported.</p>
        </div>
        <div className="flex justify-center" data-id="element-223">
          <Button link={checkoutUrl} data-id="element-224">Try the 7-Day Reset – Just $9 ➔</Button>
        </div>
      </div>
    </section>;
};